import React from 'react'
import PropTypes from 'prop-types';
import TransferListBase from 'components/complex/transferList/TransferList'
import CandidateColumn from './CandidateColumn';
import CommissionColumn from './CommissionColumn';


function TransferList(
    {
        formikProps,
        userListAvailable,
        doLoadHistory,
        markHistorical
    }) {

    return (
        <TransferListBase
            leftColumn={
                <CandidateColumn
                    items={userListAvailable}
                    formikProps={formikProps}
                    addedId='users'
                    markHistorical={markHistorical}
                />
            }
            rightColumn={
                <CommissionColumn
                    doLoadHistory={doLoadHistory}
                    id='users'
                    establishmentId='establishmentDate'
                    formikProps={formikProps}
                />
            }
        />
    )
}

TransferList.propTypes = {
    classes: PropTypes.any,
    markHistorical: PropTypes.func
};

export default TransferList;